// extracted by mini-css-extract-plugin
export var avatarContainer = "_4m-1";
export var largeAvatarContainer = "_4m-2";
export var smallAvatarContainer = "_4m-0";